import render from './render'

export default {
  name: 'JivoSite',

  render
}
